import { Component } from '@angular/core';
import { RoutingSection } from '@models/app-router.config';
import { AccountService } from '@services/account.service';
import { VisibilityService } from '@services/visibility.service';

@Component({
  selector: 'ebs-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage {
  public get routes(): RoutingSection[] {
    return this.visibilityService.getAuthorizedRoutes();
  }

  constructor(
    private visibilityService: VisibilityService,
    private accountService: AccountService,
  ) {}
}
